// extracted by mini-css-extract-plugin
export default {"container":"DashboardStat_container__cxmm3","title":"DashboardStat_title__O9rlG","count":"DashboardStat_count__1p9dP","units":"DashboardStat_units__EQZNq"};